var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.RELEASE_VERSION))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }